// shoppingcartReducer.js
import { persistReducer } from 'redux-persist';

import { SET_ALLCHECKOUTCONTEXT_DATA, SET_BILLINGADDRESSSELECT_DATA, SET_CHECKOUTCONTEXTINITIAL_DATA, SET_SELECTUSER_DATA} from '../../actions/checkoutactions/checkoutActions';


const initialState = {
  //initialpaymentmethod: [ { iddata: null, quantityall: null, totalprice: null, totalpriceformat: null }, ],
  checkoutcontextall: {
    checkoutcontextselect: {
      select_billingaddressdata: {}, // Hier wird die Rechnungsadresse gespeichert
      select_shippingaddressdata: {}, // Hier wird die Lieferadresse gespeichert
      select_paymentmethods: [], // Hier können Zahlungsmethoden gespeichert werden
      select_userdata: [],
      // weitere Felder nach Bedarf hinzufügen
    },
    // andere Felder können hier hinzugefügt werden
  },

};

const checkoutcontextallReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALLCHECKOUTCONTEXT_DATA:
      return {
        ...state,
        checkoutcontextall: action.payload,
      };


      case SET_CHECKOUTCONTEXTINITIAL_DATA:
      return {
              ...state,
              checkoutcontextall: {
                ...state.checkoutcontextall,
                checkoutcontextinitial: action.payload, 
              },
            };

      case SET_BILLINGADDRESSSELECT_DATA:
      return {
        ...state,
        checkoutcontextall: {
          ...state.checkoutcontextall,
          checkoutcontextselect: {
            ...state.checkoutcontextall.checkoutcontextselect,
            select_billingaddressdata: action.payload, // Aktualisierung der Rechnungsadresse
          },
        },
      };

      case SET_SELECTUSER_DATA:
        return {
          ...state,
          checkoutcontextall: {
            ...state.checkoutcontextall,
            checkoutcontextselect: {
              ...state.checkoutcontextall.checkoutcontextselect,
              select_userdata: action.payload, // Aktualisierung der Rechnungsadresse
            },
          },
              };

      
   
      default:
        return state;
    }
  
 
  
};



//export default persistedReducer;
export default checkoutcontextallReducer;